export function useMentions() {
  const getMentionTriggerInfo = (textarea, cursorPosition) => {
    const text = textarea.innerHTML;
    const textBeforeCursor = text.substring(0, cursorPosition);

    const lastAtIndex = textBeforeCursor.lastIndexOf('@');

    if (lastAtIndex === -1) {
      return null;
    }

    const charBeforeAt = lastAtIndex > 0 ? textBeforeCursor[lastAtIndex - 1] : null;

    const isValidContext = lastAtIndex === 0 ||
                          charBeforeAt === ' ' ||
                          charBeforeAt === '\n' ||
                          charBeforeAt === '>' ||
                          textBeforeCursor.substring(lastAtIndex - 6, lastAtIndex) === '&nbsp;';

    if (!isValidContext) {
      return null;
    }

    const searchQuery = textBeforeCursor.substring(lastAtIndex + 1);

    if (searchQuery.includes('\n') ||
        searchQuery.includes(' ') ||
        searchQuery.includes('<') ||
        /\s[^a-zA-Z]/.test(searchQuery)) {
      return null;
    }

    if (searchQuery.length > 50) {
      return null;
    }

    return {
      startIndex: lastAtIndex,
      endIndex: cursorPosition,
      searchQuery: searchQuery.trim(),
      rawQuery: searchQuery,
      isActive: true
    };
  };
  
  const getCaretPosition = (textarea) => {
    textarea.focus();
    let _range = document.getSelection().getRangeAt(0);
    let range = _range.cloneRange();
    range.selectNodeContents(textarea);
    range.setEnd(_range.endContainer, _range.endOffset);
    return range.toString().length;
  };
  
  const insertMention = (textarea, mentionInfo, user) => {
    const text = textarea.innerHTML;
    const mention = `@${user.display_name}`;

    const beforeMention = text.substring(0, mentionInfo.startIndex);
    const afterMention = text.substring(mentionInfo.endIndex);
    const newText = `${beforeMention}<span class="bg-zt-light/80 border-zt-light rounded-[2px] px-1" data-mention="${user.display_name}">${mention}</span>&nbsp;${afterMention}`;

    return {newText , id: user.ID};
  };
  
  const extractMentionsFromText = (text) => {
    const mentionRegex = /@([a-zA-Z0-9_\s]+?)(?=\s|$|[^\w\s])/g;
    const mentions = [];
    let match;
    
    while ((match = mentionRegex.exec(text)) !== null) {
      mentions.push({
        fullMatch: match[0],
        username: match[1].trim(),
        startIndex: match.index,
        endIndex: match.index + match[0].length
      });
    }
    
    return mentions;
  };
  
  const convertMentionsToLinks = (text) => {
    return text.replace(/@([a-zA-Z0-9_\s]+?)(?=\s|$|[^\w\s])/g, (match, username) => {
      const cleanUsername = username.trim();
      return `<span class="user-mention" data-username="${cleanUsername}">@${cleanUsername}</span>`;
    });
  };
  
  const stripHTML = (text) => {
    if (!text) return '';
    return text.replace(/<[^>]*>/g, '');
  };

  const cleanBrokenMentions = (textarea) => {
    if (!textarea) return;
    const selection = window.getSelection();
    let cursorOffset = 0;
    let cursorNode = null;

    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      cursorNode = range.startContainer;
      cursorOffset = range.startOffset;
    }

    const mentionSpans = textarea.querySelectorAll('span');

    mentionSpans.forEach(span => {
      const content = span.textContent;
      const originalMention = span.getAttribute('data-mention');

      const isBroken = !content ||
                      !content.startsWith('@') ||
                      (originalMention && content !== `@${originalMention}`);

      if (isBroken) {
        const textNode = document.createTextNode(content || '');

        const wasCursorInSpan = span.contains(cursorNode) || cursorNode === span;

        const nextSibling = span.nextSibling;
        const hasNbsp = nextSibling?.nodeType === Node.TEXT_NODE &&
                       nextSibling.textContent.startsWith('\u00A0');

        span.parentNode.replaceChild(textNode, span);

        if (hasNbsp && nextSibling) {
          nextSibling.textContent = nextSibling.textContent.slice(1);
        }

        if (wasCursorInSpan && selection.rangeCount > 0) {
          const newRange = document.createRange();
          const newOffset = Math.min(cursorOffset, textNode.textContent.length);
          newRange.setStart(textNode, newOffset);
          newRange.collapse(true);
          selection.removeAllRanges();
          selection.addRange(newRange);
        }
      }
    });
  };

  return {
    getMentionTriggerInfo,
    getCaretPosition,
    insertMention,
    extractMentionsFromText,
    convertMentionsToLinks,
    stripHTML,
    cleanBrokenMentions
  };
}
